import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-arrow-clockwise"
}
const _hoisted_2 = { class: "au-card" }
const _hoisted_3 = { class: "au-card-head" }
const _hoisted_4 = { class: "au-card-title" }
const _hoisted_5 = {
  key: 0,
  class: "au-select"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "au-search ms-auto" }
const _hoisted_10 = ["placeholder", "aria-label"]
const _hoisted_11 = {
  key: 0,
  class: "au-empty"
}
const _hoisted_12 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_13 = { class: "visually-hidden" }
const _hoisted_14 = {
  key: 1,
  class: "au-empty"
}
const _hoisted_15 = { class: "au-empty-title" }
const _hoisted_16 = {
  key: 2,
  class: "au-empty"
}
const _hoisted_17 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_18 = { class: "table table-hover" }
const _hoisted_19 = ["aria-sort"]
const _hoisted_20 = ["title", "onClick"]
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = ["onClick", "onKeydown"]
const _hoisted_23 = { class: "au-entity" }
const _hoisted_24 = { style: {"min-width":"0"} }
const _hoisted_25 = { class: "au-entity-name" }
const _hoisted_26 = { class: "au-entity-sub" }
const _hoisted_27 = {
  key: 0,
  class: "au-lic-sub"
}
const _hoisted_28 = {
  key: 1,
  class: "spinner-border spinner-border-sm text-primary",
  role: "status"
}
const _hoisted_29 = { class: "visually-hidden" }
const _hoisted_30 = { class: "au-actions" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 4,
  class: "au-card-foot"
}
const _hoisted_35 = { class: "d-none d-md-inline" }
const _hoisted_36 = {
  key: 0,
  class: "au-pages"
}
const _hoisted_37 = ["disabled", "aria-label"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_page_header = _resolveComponent("bs5-page-header")!
  const _component_bs5_action_menu = _resolveComponent("bs5-action-menu")!
  const _component_ClientPanel = _resolveComponent("ClientPanel")!
  const _component_AddClientModal = _resolveComponent("AddClientModal")!
  const _component_EditClientModal = _resolveComponent("EditClientModal")!
  const _component_GenerateLicenseModal = _resolveComponent("GenerateLicenseModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_bs5_page_header, {
      title: _ctx.$t('clients.title'),
      subtitle: _ctx.$t('clients.subtitle')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_bs5_base_button, {
          variant: "secondary",
          loading: _ctx.loading,
          onClick: _ctx.fetchAll
        }, {
          default: _withCtx(() => [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t("common.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_bs5_base_button, {
          variant: "primary",
          disabled: _ctx.distributors.length === 0,
          onClick: _ctx.openAddClientModal
        }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t("clients.new")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-list-ul" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t("clients.list")), 1)
        ]),
        (_ctx.distributors.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-shop" }, null, -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDistributorId) = $event)),
                class: "form-select",
                "aria-label": _ctx.$t('clients.distributor')
              }, [
                _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("clients.allDistributors", { count: _ctx.clients.length })), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributorOptions, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.id,
                    value: option.id
                  }, _toDisplayString(_ctx.$t("clients.distributorOption", { name: option.name, count: option.count })), 9, _hoisted_8))
                }), 128))
              ], 8, _hoisted_6), [
                [_vModelSelect, _ctx.selectedDistributorId]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            class: "form-control",
            placeholder: _ctx.$t('clients.search'),
            "aria-label": _ctx.$t('clients.search')
          }, null, 8, _hoisted_10), [
            [_vModelText, _ctx.search]
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("common.loading")), 1)
            ])
          ]))
        : (_ctx.clients.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-briefcase" }, null, -1)),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("clients.emptyTitle")), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("clients.emptyText")), 1)
            ]))
          : (_ctx.filteredClients.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-search" }, null, -1)),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("clients.noResults")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: column.key,
                          "aria-sort": _ctx.ariaSort(column.key)
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["au-th-sort", { 'is-sorted': _ctx.sortKey === column.key }]),
                            title: _ctx.$t('clients.sortBy', { column: _ctx.$t(column.labelKey) }),
                            onClick: ($event: any) => (_ctx.sortBy(column.key))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(['bi', column.icon])
                            }, null, 2),
                            _createTextVNode(_toDisplayString(_ctx.$t(column.labelKey)) + " ", 1),
                            _createElementVNode("i", {
                              class: _normalizeClass(['bi', _ctx.sortIcon(column.key)])
                            }, null, 2)
                          ], 10, _hoisted_20)
                        ], 8, _hoisted_19))
                      }), 128)),
                      _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("common.actions")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedClients, (client) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: client.id as string,
                        class: "au-row-link",
                        tabindex: "0",
                        onClick: ($event: any) => (_ctx.openPanel(client)),
                        onKeydown: _withKeys(($event: any) => (_ctx.openPanel(client)), ["enter"])
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_23, [
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "au-avatar" }, [
                              _createElementVNode("i", { class: "bi bi-buildings" })
                            ], -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(client.name), 1),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-chat-left-text" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(client.description || _ctx.$t("clients.noDescription")), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["au-chip", `is-${client.tone}`])
                          }, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-shop" }, null, -1)),
                            _createTextVNode(_toDisplayString(client.distributorName), 1)
                          ], 2)
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.summaries[client.id as string])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["au-lic-status", `is-${_ctx.summaries[client.id as string].tone}`])
                                }, [
                                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "au-lic-dot" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.summaries[client.id as string].text), 1)
                                ], 2),
                                (_ctx.summaries[client.id as string].detail)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.summaries[client.id as string].detail), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("common.loading")), 1)
                              ]))
                        ]),
                        _createElementVNode("td", {
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_bs5_base_button, {
                              variant: "soft",
                              size: "sm",
                              onClick: ($event: any) => (_ctx.openGenerateLicenseModal(client.id as string))
                            }, {
                              default: _withCtx(() => [
                                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-file-earmark-plus" }, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t("clients.generateLicense")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_bs5_action_menu, {
                              label: _ctx.$t('clients.more')
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "au-menu-item",
                                  role: "menuitem",
                                  onClick: ($event: any) => (_ctx.openPanel(client))
                                }, [
                                  _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-layout-sidebar-reverse" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.$t("clients.openPanel")), 1)
                                ], 8, _hoisted_31),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "au-menu-item",
                                  role: "menuitem",
                                  onClick: ($event: any) => (_ctx.editClient(client.id as string))
                                }, [
                                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)
                                ], 8, _hoisted_32),
                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "au-menu-sep" }, null, -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "au-menu-item is-danger",
                                  role: "menuitem",
                                  onClick: ($event: any) => (_ctx.deleteClient(client))
                                }, [
                                  _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-trash3" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.$t("clients.deleteClient")), 1)
                                ], 8, _hoisted_33)
                              ]),
                              _: 2
                            }, 1032, ["label"])
                          ])
                        ], 32)
                      ], 40, _hoisted_22))
                    }), 128))
                  ])
                ])
              ])),
      (!_ctx.loading && _ctx.filteredClients.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.range", { from: _ctx.rangeFrom, to: _ctx.rangeTo, total: _ctx.filteredClients.length })), 1),
            _createElementVNode("span", _hoisted_35, [
              _cache[25] || (_cache[25] = _createElementVNode("i", { class: "bi bi-hand-index me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("clients.rowHint")), 1)
            ]),
            (_ctx.pageCount > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.page === 1,
                    "aria-label": _ctx.$t('common.previous'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.page--))
                  }, _cache[26] || (_cache[26] = [
                    _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
                  ]), 8, _hoisted_37),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageCount, (pageNumber) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: pageNumber,
                      type: "button",
                      class: _normalizeClass({ 'is-active': pageNumber === _ctx.page }),
                      onClick: ($event: any) => (_ctx.page = pageNumber)
                    }, _toDisplayString(pageNumber), 11, _hoisted_38))
                  }), 128)),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: _ctx.page === _ctx.pageCount,
                    "aria-label": _ctx.$t('common.next'),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.page++))
                  }, _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
                  ]), 8, _hoisted_39)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ClientPanel, {
      visible: _ctx.panelOpen,
      client: _ctx.panelClient,
      licenses: _ctx.panelLicenses,
      loading: _ctx.panelClient ? !_ctx.licensesByClient[_ctx.panelClient.id as string] : false,
      newLicenseIds: _ctx.newLicenseIds,
      onClose: _ctx.closePanel,
      onEdit: _ctx.editClient,
      onIssue: _ctx.openGenerateLicenseModal,
      onChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.reloadLicenses(_ctx.panelClientId)))
    }, null, 8, ["visible", "client", "licenses", "loading", "newLicenseIds", "onClose", "onEdit", "onIssue"]),
    _createVNode(_component_AddClientModal, {
      visible: _ctx.showAddClientModal,
      distributorId: _ctx.addDistributorId,
      distributors: _ctx.distributors,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddClientModal = false)),
      onClientAdded: _ctx.fetchAll
    }, null, 8, ["visible", "distributorId", "distributors", "onClientAdded"]),
    _createVNode(_component_EditClientModal, {
      visible: _ctx.showEditClientModal,
      clientId: _ctx.selectedClientId,
      onClose: _cache[8] || (_cache[8] = () => { _ctx.showEditClientModal = false; _ctx.selectedClientId = '' }),
      onClientUpdated: _ctx.fetchAll
    }, null, 8, ["visible", "clientId", "onClientUpdated"]),
    _createVNode(_component_GenerateLicenseModal, {
      visible: _ctx.showGenerateLicenseModal,
      clientId: _ctx.selectedClientId,
      onClose: _cache[9] || (_cache[9] = () => { _ctx.showGenerateLicenseModal = false; _ctx.selectedClientId = '' }),
      onLicenseGenerated: _ctx.onLicenseGenerated
    }, null, 8, ["visible", "clientId", "onLicenseGenerated"])
  ]))
}